//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [],
    data () {
        return {
            dialogVisible: false,
            form: {
                pwd: '',
                newmobile: '',
                checknewmobile: ''
            }
        }
    },
    computed: {
        newPswRules() {
            var rule = this.newRule('新密码', 'required');
            rule.push({
                validator: this.checkNewPwd,
                trigger: 'blur'
            });
            return rule;
        },
        checknewpwdRules() {
            var rule = this.newRule('确认新密码', 'required');
            rule.push({
                validator: this.checkPwd,
                trigger: 'blur'
            });
            return rule;
        }
    },
    watch: {
        dialogVisible(n) {
            if(n) return;
            this.form = {
                pwd: '',
                newmobile: '',
                checknewmobile: ''
            };
        }
    },
    methods: {
        show() {
            this.dialogVisible = true;
        },
        close() {
            this.dialogVisible = false;
        },
        checkPwd(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.newpwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        },
        submit: function(){
            this.$post(this.getStore('sysUrl') + '/user/changepwd', this.form, (data, res) => {
                ShowMsg.call(this, res.msg, 'success');
                this.close();

                this.$store.dispatch('logout');
            });
        },
        checkNewPwd (rule, value, callback) {
            if (!(/^(?=.*[a-zA-Z]+)(?=.*[0-9]+)[a-zA-Z0-9]+$/.test(value))) {
                callback(new Error('密码格式错误,应为6位以上数字字母组合'));
            } else if (value.length < 6) {
                callback(new Error('密码长度最少为6位'));
            } else {
                callback()
            }
        }
    },
    mounted: function() {

    }
}
